import * as React from 'react';

import logger from 'js/app/loggerSingleton';
import { setLocation } from 'js/lib/coursera.redirect';

import { Button, Link } from '@coursera/cds-core';
import type { ButtonName } from '@coursera/event-pulse-types';

import { enrollThroughFreemium, useFreemiumTracking } from 'bundles/enroll-common/utils/freemiumModelUtils';

import _t from 'i18n!nls/enroll';

const CoursePreviewLink = ({
  courseId,
  courseSlug,
  variant = 'link',
  shouldStopPropagation = false,
  trackingName,
}: {
  courseId: string;
  courseSlug?: string;
  variant?: 'button' | 'link';
  shouldStopPropagation?: boolean;
  trackingName: ButtonName;
}) => {
  const { trackPreviewLinkView, trackPreviewLinkClick } = useFreemiumTracking(trackingName);

  React.useEffect(() => {
    trackPreviewLinkView();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const redirectToCourseHome = () => {
    if (courseSlug) {
      return setLocation(`/learn/${courseSlug}/home/welcome`);
    }

    return setLocation('/');
  };

  const onClickPreviewCourse = (e: React.SyntheticEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (shouldStopPropagation) {
      e.stopPropagation();
    }

    trackPreviewLinkClick();

    enrollThroughFreemium(courseId)
      .then(redirectToCourseHome)
      .catch((error) => {
        logger.error(`CoursePreviewLink: error enrolling through freemium on XDP via ${variant} click`, error);
      });
  };

  if (variant === 'button') {
    return (
      <Button variant="ghost" onClick={onClickPreviewCourse}>
        {_t('Preview')}
      </Button>
    );
  }

  return (
    <div>
      <Link component="button" onClick={onClickPreviewCourse}>
        {_t('Preview')}
      </Link>
    </div>
  );
};

export default CoursePreviewLink;
